import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';

// HelmetProvider must wrap the whole tree so any page's <Seo> can write into
// <head>. It works transparently in the browser; the Netlify Prerender
// extension renders the real page in a headless browser, so the head tags each
// route sets are present in the HTML that crawlers receive.

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
